import { render, staticRenderFns } from "./edit-quote.vue?vue&type=template&id=16ea1397&scoped=true"
import script from "./edit-quote.vue?vue&type=script&lang=js"
export * from "./edit-quote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ea1397",
  null
  
)

export default component.exports